<!-- 移动端组态设置 -->
<template>
    <div class='container containerBox'>
        <div id="drawing" style="display:block;"></div>
        <el-form :inline="true" class="demo-form-inline">
            <template v-for="(v, i) in deviceList">
                <el-row :gutter="5" :key="i">
                    <el-col :span="2">
                        <el-form-item label="排序">
                            <el-input style="width:60px;" v-model.number="v.sort" placeholder="排序"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="设备名称">
                            <el-input v-model="v.name" placeholder="设备名称"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="5">
                        <el-form-item label="设备分类">
                            <el-select v-model="v.deviceType" placeholder="请选择">
                                <el-option
                                    v-for="item in deviceType"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.type">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="5">
                        <el-form-item label="addr">
                            <el-input v-model="v.node_var[0].var_addr" placeholder="设备地址" :disabled="true"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="addr名称">
                            <el-input v-model="v.node_var[0].var_name" placeholder="设备名称" :disabled="true"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </template>
            <el-form-item>
                <el-button type="primary" @click="handleSave">保存</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>
<script src="/static/js/svg-pan-zoom.min.js"></script>
<script>
import Service from '@/api/Service'

const NODETYPE = ['GD_Z', 'GD_V','GD_H', 'GD_Z' ]
const type = [
    {
		name: '主机',
		id: 'ZJ',
		type: 'ZJ',
	}, {
		name: '冷却塔',
		id: 'LQT',
		type: 'LQT',
	}, {
		name: '冷却阀',
		id: 'LQF',
		type: 'LQF',
	}, {
		name: '冷冻阀',
		id: 'LDF',
		type: 'LDF',
	},{
		name: '冷却泵',
		id: 'LQB',
		type: 'LQB',
	},{
		name: '冷冻泵',
		id: 'LDB',
		type: 'LDB',
	},{
		name: '状态类',
		id: 'OTHER',
		type: 'OTHER',
	}
]
export default {
    name:  'mobileMonitoring',
    data() {
        return {
            oid: "",

            deviceList: [],
            deviceType: type,
            
            drag: null,
            dragGroup: null,
        };
    },

    components: {},

    computed: {},

    created() {
        this.oid = this.$route.params.id;
        this.getData();
    },

    mounted() {
        let that = this;  
        this.$nextTick(()=>{
            this.drag = new SVG("drawing").size(1, 1);
        })
    },

    methods: {
        getData: async function() {
            // 获取机房监控
            let res = await Service.getServerroombypid();
            if(res !== 'success') {
				let map_value_computer = res[0].map_value_computer
				this.deviceList = this.fmtDeviceData(map_value_computer)
            }
        },
        fmtDeviceData(data){
            let deviceList = [];
            this.drag.svg(data)
            this.dragGroup = this.drag.last()
            //存储节点信息
            let nodes = this.dragGroup.children()
            for (let i = 0; i < nodes.length; i++) {
                const ele = nodes[i];
                let node_id = ele.node.id,
                    node_type = ele.node.dataset.type,
                    dataset = ele.node.dataset;

                if(node_type === 'BUTTON'){
                    continue
                }
                // 过滤未绑定地址节点
                if( dataset.type !=null && dataset.params !== undefined && dataset.params !== null){
                    // 存储设备节点
                    if(NODETYPE.indexOf(dataset.type) === -1 && dataset.type.indexOf("LINE") === -1) {
                        let params = JSON.parse(dataset.params)
                        deviceList.push()
                    }
                }
            }
            return deviceList
        },
        async handleSave() {
            let data = this.deviceList
            
            let params = {
                map_value_phone: JSON.stringify(data),
                oid: Number(this.oid),
                map_type: 1, 
            }
            let res = await Service.editMapServerroom(params);
            if(res) {
                this.$message({
                    type: 'success',
                    message: '操作成功!'
                });
                this.$router.push("/machinemana") 
            }
        },
    }
}

</script>
<style lang='less' scoped>

</style>